import React from "react";
import HeroImage from "../../assests/download.jpg";
function Hero() {
  return (
    <div>
      <img src="https://static.vecteezy.com/system/resources/previews/004/299/835/original/online-shopping-on-phone-buy-sell-business-digital-web-banner-application-money-advertising-payment-ecommerce-illustration-search-free-vector.jpg" />
    </div>
  );
}

export default Hero;
